import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import listViewStore from 'mini-mail-list-store/lib/store/Store';
import MailListViewSecondaryHeader from './MailListViewSecondaryHeader';
import MailSearchFilter from '../components/MailSearchFilter';
import React from 'react';
import styles from './MailListHeader.scss';
import { observer } from 'mobx-react-lite';
import { type TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

const MailListHeader = ({ forwardedRefs }) => {
    const isSearchView = listViewStore.shouldShowSearchBox;
    const selectedTableView = getSelectedTableView();

    if (isSearchView) {
        if (selectedTableView?.tableQuery.type === 1) {
            return (
                <div className={styles.searchFilter}>
                    <MailSearchFilter />
                </div>
            );
        }

        return null;
    }

    return <MailListViewSecondaryHeader forwardedRefs={forwardedRefs} />;
};

export default observer(MailListHeader);
